import React, { useState } from 'react';
import TaskListBase from './TaskListBase.jsx';
import TaskLayout from './TaskLayout.jsx';
import NewTaskButton from './top/NewTaskButton.jsx';
import TaskColumnSelector from './top/TaskColumnSelector.jsx';
import TaskSearchBar from './top/TaskSearchBar.jsx';
import TaskServerSideDatagrid from './datagrid/TaskServerSideDatagrid.jsx';
import ToggleButtonGroup from '../common/ToggleButtonGroup.jsx';
import TaskServerSideKanbanView from './datagrid/TaskServerSideKanbanView.jsx';
import Button from '../bootstrap/Button.jsx';
import { FaIcon } from '../common/Icons.jsx';
import PresetDropdown from './top/PresetDropdown.jsx';
import queryClient from '../../../query_client.js';

const BASE_QUERY_KEY = 'tasksProgrammeList';

function TaskProgrammeList({ projectId, permissions, advancedFeatures }) {
  const [reloadClick, setReloadClick] = useState(0);

  return (
    <TaskListBase projectId={projectId} includePresets={true}>
      {({
        btnStyle,
        groupGridItems,
        activeView,
        gridGroupToggleProps,
        listKanbanToggleProps,
        presetId,
        setPresetId
      }) => (
        <TaskLayout
          left={<>
            {permissions.create_task && (
              <NewTaskButton projectId={projectId} portalProps={{ projectId, programmeId: projectId }} btnStyle={btnStyle} />
            )}
            <TaskColumnSelector projectId={projectId} btnStyle={btnStyle} />
            {advancedFeatures && <ToggleButtonGroup {...listKanbanToggleProps} />}
            {activeView === 'list' && <ToggleButtonGroup {...gridGroupToggleProps} />}
            <PresetDropdown presetId={presetId} setPresetId={setPresetId} projectId={projectId} btnStyle={btnStyle} />
            <Button type='default' style={btnStyle} onClick={() => {
              queryClient.invalidateQueries([BASE_QUERY_KEY]);
              setReloadClick(prev => prev + 1);
            }} title={I18n.t('refresh')}>
              <FaIcon type='refresh' />
            </Button>
          </>}
          right={<TaskSearchBar />}
        >
          {activeView === 'list' && <TaskServerSideDatagrid
            programmeId={projectId}
            projectId={projectId}
            groupGridItems={groupGridItems}
            presetId={presetId}
            permissions={permissions}
            baseQueryKey={BASE_QUERY_KEY}
            reloadClick={reloadClick}
            advancedFeatures={advancedFeatures}
          />}
          {activeView === 'kanban' && <TaskServerSideKanbanView
            programmeId={projectId}
            projectId={projectId}
            presetId={presetId}
            permissions={permissions}
            baseQueryKey={BASE_QUERY_KEY}
            reloadClick={reloadClick}
            advancedFeatures={advancedFeatures}
          />}
        </TaskLayout>
      )}
    </TaskListBase>
  );
}

export default TaskProgrammeList;
